define("shared/utils/upgrade/choose-your-upgrade", ["exports", "later/utils/constants"], function (_exports, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.upgradeFeatures = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/utils/constants"eaimeta@70e063a35619d71f
  const upgradeFeatures = intl => ({
    [_constants.ChooseYourUpgradeFeature.LinkinbioBrandedBanner]: {
      title: intl.t('plans.choose_your_upgrade.branded_banner.title'),
      upgradeOptions: [{
        highlights: [intl.t('plans.choose_your_upgrade.branded_banner.remove_banner.highlight_1')],
        image: '/assets/images/img--libUpgrade--growth.png',
        location: 'later banner option none',
        planName: 'growth',
        selectedByDefault: true,
        title: intl.t('plans.choose_your_upgrade.branded_banner.remove_banner.title'),
        upgradeFeature: 'linkinbioBannerless'
      }]
    }
  });
  _exports.upgradeFeatures = upgradeFeatures;
});